<template>
  <div class="xiangs">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="xiangstab">
      <el-form ref="dashboardForm" :model="dashboardForm" class="xiang">
        <ul :class="{showall:true,active:showall}">
          <!-- 4. 投标保证保险 -->
          <li @click="bidSecurity(4)">
            <div class="inner">
              <h1 class="name">投标保证保险</h1>
              <div class="tel">
                <p>咨询电话：400-666-7151</p>
              </div>
            </div>
          </li>
          <!-- 5. 合同履约保证保险 -->
          <li @click="bidSecurity(5)">
            <div class="inner">
              <h1 class="name">合同履约保证保险</h1>
              <div class="tel">
                <p>咨询电话：400-666-7151</p>
              </div>
            </div>
          </li>
          <!-- 9. 预付款保证保险 -->
          <li @click="bidSecurity(9)">
            <div class="inner">
              <h1 class="name">预付款保证保险</h1>
              <div class="tel">
                <p>咨询电话：400-666-7151</p>
              </div>
            </div>
          </li>
          <!-- 7. 农民工工资支付保证保险 -->
          <li @click="bidSecurity(7)">
            <div class="inner">
              <h1 class="name">农民工工资支付保证保险</h1>
              <div class="tel">
                <p>咨询电话：400-666-7151</p>
              </div>
            </div>
          </li>
          <!-- 6. 工程款支付保证保险 -->
          <li @click="bidSecurity(6)">
            <div class="inner">
              <h1 class="name">工程款支付保证保险</h1>
              <div class="tel">
                <p>咨询电话：400-666-7151</p>
              </div>
            </div>
          </li>
        </ul>
      </el-form>
    </el-tabs>
    <!-- 保险保函弹出框-->
    <el-dialog title="购买保函须知" :visible.sync="xuzhiVisible" width="560px" :append-to-body="true">
      <div class="outtext" v-html="content"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="xuzhiVisible = false">不同意，取消</el-button>
        <el-button type="primary" @click="toPage(id,code)">我已阅读须知并同意</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import auth from '@/utils/auth'
import utils from '@/utils/utils'
import { GetISBidDoc, GetInsureCode } from '@/api/insure'
import { GetCompany } from '@/api/company'
// import auth from "@/utils/auth";
// import zhaoBiaoFrom from '../page/ZhaobiaoFrom.vue';
export default {
  name: 'Dashboard.vue',
  data() {
    return {
      showall: false,
      content: '',
      xuzhiVisible: false,
      dashboardForm: {
        id: '',
        name: '',
        info: '1',
        tl: '',
        t2: '',
        t6: '',
        t3: '',
        t4: '',
        tle5: '',
        tle20: '',
        tle21: '',
        tle22: '',
        tle23: '',
        t7: '',
        t8: ''
      },
      activeName: 'first',
      id: 0,
      code: '',
      provinceCode: null
    }
  },
  created() {
    // -- 查询当前企业所属地区
    this.provinceCode = localStorage.getItem('compArea')
    // console.log('this.provinceCode:' + this.provinceCode)
    if (this.provinceCode == undefined || this.provinceCode == null) {
      GetCompany({
        uuid: auth.getcmpid(),
        sessionToken: auth.getToken()
      })
        .then(res => {
          if (res.code === 20000) {
            localStorage.setItem('compArea', res.data.province)
            this.provinceCode = res.data.province + ''
            // console.log('公司：' + JSON.stringify(res))
            // console.log(' this.provinceCode：' + this.provinceCode)
          }
        })
        .catch(res => {
          // this.$message("请与管理员联系");
        })
    }
  },
  methods: {
    //跳转到投标保证保函
    bidSecurity(id) {
      var isCertification = localStorage.getItem('jz_isCertification')

      //   console.log('是否认证' + JSON.stringify(isCertification))
      if (isCertification === '1') {
        if (id == 11) {
          //担保保函
          var url =
            utils.getTZUrl() +
            'danbaobaohan?id=' +
            4 +
            '&code=' +
            code +
            '&token=' +
            auth.getToken()
          //首先校验code码
          GetInsureCode({
            itype: id,
            code: code,
            sessionToken: auth.getToken()
          })
            .then(res => {
              if (res.code === 20000) {
                // console.log('123返回数据' + JSON.stringify(res))
                window.location.href = url
              } else {
                this.$message(JSON.stringify(res.msg))
              }
            })
            .catch(res => {
              this.$message('请与管理员联系')
            })
          //   window.location.href = url
        } else {
          //首先通过查询code,判断token是否已经失效。如果失效应该回login页面
          GetInsureCode({
            itype: id,
            code: 'code',
            sessionToken: auth.getToken()
          })
            .then(res => {
              if (res.code === 20000) {
                this.toPage(id)
              } else {
                if (res.msg == '输入的Code不正确，请检查') {
                  this.toPage(id)
                }
                // this.$message(JSON.stringify(res.msg))
              }
            })
            .catch(res => {
              this.$router.push('/login')
            })
          //   this.toPage(id)
        }
      } else {
        this.$message('您未进行认证，请先认证')
        this.$router.push('/renzheng')
      }
    },
    toPage(id) {
      //   console.log('topange')
      var url = ''
      switch (id) {
        case 4:
          url =
            utils.getTZUrl() +
            'NotCode/bidSecurity?id=' +
            id +
            '&token=' +
            auth.getToken()
          window.location.href = url
          break
        case 5:
          url =
            utils.getTZUrl() +
            'NotCode/contractPerformance?id=' +
            id +
            '&token=' +
            auth.getToken()
          window.location.href = url
          break
        case 7:
          url =
            utils.getTZUrl() +
            'NotCode/migrantWorkers?id=' +
            id +
            '&token=' +
            auth.getToken()
          window.location.href = url
          break
        case 6:
          url =
            utils.getTZUrl() +
            'NotCode/projectPayment?id=' +
            id +
            '&token=' +
            auth.getToken()
          window.location.href = url
          break
        case 9:
          url =
            utils.getTZUrl() +
            'NotCode/prepayments?id=' +
            id +
            '&token=' +
            auth.getToken()
          window.location.href = url
          break
      }
    },
    handleClick(tab, event) {
      //   console.log(tab, event)
    }
  }
}
</script>
<style scoped>
/*收缩框*/
.showall {
  height: 620px;
  overflow: hidden;
  clear: both;
}
.showall.active {
  height: auto;
}

/* 样式 */
.xiangs {
  width: 90%;
  text-align: center;
  margin: 0px auto;
  padding: 40px 0 0 0;
  /* border: 3px solid #e3a720; */
  /* min-height: 500px; */
}
.xiang {
  width: 85%;
  text-align: left;
  margin: 0px auto;
  padding: 0px;
}
.xiang .more {
  text-align: right;
  padding: 10px 15px;
}

.xiang ul {
  padding: 0;
  margin: 0;
}
.xiang li {
  padding: 0;
  width: calc((100% - 100px) / 3);
  display: inline-block;
  vertical-align: top;
  margin: 20px 40px 20px 0px;
}
.xiang .inner {
  text-align: center;
  padding: 0;
  border-radius: 10px;
  position: relative;
  height: 270px;
  border: 4px solid #f7b525;
  background: linear-gradient(to top, #f6f0e0, #ffffff);
  cursor: pointer;
}
.xiang li:nth-child(3n + 0) {
  margin: 20px 0px 20px 0px !important;
}
.xiang .inner:hover {
  border: 4px solid #d39205;
  background: linear-gradient(to top, #fceec4, #f6f0e0);
  box-shadow: 0px 0px 15px #fceec4;
}
.xiang .inner .name {
  padding-top: 60px;
  line-height: 35px;
  font-size: 36px;
  color: #fa5606;
  cursor: pointer;
}
.xiang .inner .tel {
  padding: 0px 0 25px 0;
  font-size: 16px;
  color: #7f7c7c;
}
.xiang .inner .el-button {
  width: 120px;
  background: #fff;
  color: #fa5606;
  border: 1px solid #f7b525;
}

.xiang .inner .el-button:hover,
.xiang .inner .el-button:focus {
  color: #fff;
  background: #fa5606;
}
.xiang .inner .btnbox {
  width: 70%;
  /* width: calc(100% - 80px); */
  text-align: center;
  margin: 0px auto 30px auto;
  height: 100px;
  z-index: 10;
  position: relative;
}
/deep/ .xiang .inner .btnbox .texts {
  height: 36px;
  font-size: 18px;
  background-color: #fff;
  border: 1px solid #e3a720;
  border-radius: 38px;
}
/deep/ .btnbox .el-input__inner {
  background-color: transparent !important;
  text-align: left;
  border: 1px solid transparent !important;
  border-radius: 15px;
}
.xiang .inner .btnbox .btn-go {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 38px;
  height: 38px;
  font-size: 18px;
  color: #fff;
  background-color: #e3a720;
  border-color: #e3a720;
}

/deep/ .xiangstab > .el-tabs__header {
  margin: 0;
  padding: 0;
}
/deep/ .xiangstab > .el-tabs__header .el-tabs__nav,
/deep/
  .xiangstab
  .el-tabs__header
  .el-tabs__item.is-active
  /deep/
  .xiangstab
  > .el-tabs__header
  .el-tabs__item,
/deep/ .xiangstab {
  border: 0;
  margin: 0;
  padding: 0;
}
/deep/ .xiangstab > .el-tabs__header {
  border: 0;
  background: none;
}
/deep/ .xiangstab .el-tabs__item.is-active,
/deep/ .xiangstab .el-tabs__item:hover {
  color: #000;
}
/deep/ .xiangstab > .el-tabs__header .el-tabs__item {
  width: 328px;
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  font-weight: bold;
  padding: 0 30px;
  margin: 0 -45px;
  border: 0;
  text-align: center;
  background: url('../../../static/img/tabli_bg.png') no-repeat right top;
}
/deep/ .xiangstab .el-tabs__item.is-active {
  background: url('../../../static/img/tabli_select.png') no-repeat right top;
}
/deep/ .xiangstab > .el-tabs__header .el-tabs__item.is-active {
  z-index: 999;
  border: 0;
}
/deep/ .xiangstab > .el-tabs__header .el-tabs__item:first-child {
  width: 240px;
  text-align: left;
  padding-left: 50px;
  margin: 0 -45px 0 0;
}
/deep/ .xiangstab .el-tabs__content {
  min-height: 640px;
  padding: 10px 20px;
  border: 3px solid #e3a720;
  margin: 0;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 0px solid #e4e7ed;
  border-bottom: none;
}

/* @media screen and (max-width: 1500px) {
} */
</style>





// WEBPACK FOOTER //
// src/components/page/Dashboard.vue